import styled from "styled-components";

export const AboutContainer = styled.div`
    background: #000815;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px;
    height: 700px;
    position: relative;
    z-index: 1;

    @media screen and (max-width: 768px){
        height: 750px;
    }
`
